import {
	OptimizelyLongString,
	ImageReference,
	OptimizelyXhtmlString,
} from '..';
import { OptimizelyBlockExpandedValue } from '../expanded';

export interface OptimizelyPromoBlock extends OptimizelyBlockExpandedValue {
	title: OptimizelyLongString;
	titleLink: OptimizelyLongString;
	image?: ImageReference;
	textEditor?: OptimizelyXhtmlString;
}

export const isPromoBlock = (
	block: OptimizelyBlockExpandedValue,
): block is OptimizelyPromoBlock => {
	return block.contentType[1] === 'PromoBlock';
};
